const FormResources = {

    form_data:{
        supervisor_associate_id:        '',
        shift_id:                       '',
        group_id:                       '',
        census:                         '',
        cost_center_department_id:      '',
        days_per_week:                  '',
        minutes:                        '',
        day_id: [],
        confirmation_fields: [],
    },

    form_format:[
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Supervisor:',
            model_name: 'supervisor_associate_id',
            ref:        'supervisor_associate_id_input',
            ref_alt:    'supervisor_associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Shift:',
            model_name: 'shift_id',
            ref:        'shift_id_input',
            ref_alt:    'shift_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Group:',
            model_name: 'group_id',
            ref:        'group_id_input',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  7,
            disabled:   false,
            step:       'any',
            name:       'Days per week:',
            model_name: 'days_per_week',
            ref:        'days_per_week_input',
            ref_alt:    'days_per_week_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Work Days:',
            model_name: 'day_id',
            ref:        'day_id_input',
            ref_alt:    'day_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select option(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-3',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       'any',
            name:       'Minutes/Discharge:',
            model_name: 'minutes',
            ref:        'minutes_input',
            ref_alt:    'minutes_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Include in census:',
            model_name: 'census',
            ref:        'census_input',
            ref_alt:    'census_input_alt',
            required:   false,
        },
    ],

    confirmation_form_format:[
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Supervisor',
            ref:        'supervisor_associate_id_input',
            model_name: 'confirmation_fields',
            value:      'supervisor_associate_id',
            ref_alt:    'supervisor_associate_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Group',
            ref:        'group_id_input',
            model_name: 'confirmation_fields',
            value:      'group_id',
            ref_alt:    'group_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Department',
            ref:        'cost_center_department_id_input',
            model_name: 'confirmation_fields',
            value:      'cost_center_department_id',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Census',
            ref:        'census_input',
            model_name: 'confirmation_fields',
            value:      'census',
            ref_alt:    'census_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Work Days',
            ref:        'day_id',
            model_name: 'confirmation_fields',
            value:      'day_id',
            ref_alt:    'day_id_alt',
            required:   false,
        },
    ]

}

export default FormResources;